import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
import logoImage from "../assets/images/new_vitalX_logo.svg";
import DashboardIcon from "../assets/images/icons/menu-icon-01.svg";
import AppointmentsIcon from "../assets/images/icons/menu-icon-04.svg";
import PatientsIcon from "../assets/images/icons/menu-icon-03.svg";
import QRIcon from "../assets/images/icons/menu-icon-13.svg";
import DoctorIcon from "../assets/images/icons/menu-icon-02.svg";
import PrescriptionsIcon from "../assets/images/icons/menu-icon-15.svg";
import BillingIcon from "../assets/images/icons/menu-icon-09.svg";
import { motion, AnimatePresence } from "framer-motion"; // Import motion components
import { FiMenu, FiX } from "react-icons/fi";

const SideBar = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  const handleMouseEnter = () => {
    setIsExpanded(true);
  };

  const handleMouseLeave = () => {
    setIsExpanded(false);
  };

  const { pathname } = useLocation();

  const itemLinkClass =
    "flex gap-x-2 items-center text-md min-h-[42px] py-3 h-auto text-black/70 no-underline pl-3 clear-both whitespace-nowrap customHover";
  const activeItemLinkClass =
    "flex gap-x-2 items-center text-md min-h-[42px] py-3 h-auto text-blue-800 bg-blue-50 rounded-md no-underline pl-3 clear-both whitespace-nowrap customHover";
  const menuIconClass =
    " inline-flex justify-center items-center w-10 h-10 rounded-md leading-34  text-center top-0 relative z-10 text-xl text-gray-600 bg-gray-100 font-semibold";
  const activeMenuIconClass =
    " inline-flex justify-center items-center w-10 h-10 rounded-md leading-34  text-center top-0 relative z-10 text-xl text-blue-800 bg-white font-semibold";
  const filterClass =
    " invert(13%) sepia(85%) saturate(7478%) hue-rotate(266deg) brightness(50%) contrast(340%)";

  return (
    <>
      {/* Mobile hamburger button */}
      <button
        className="md:hidden fixed top-5 left-3 z-[60] p-2 bg-white rounded-md shadow-md border border-gray-200 text-gray-800"
        onClick={() => setIsMobileOpen(!isMobileOpen)}
      >
        {isMobileOpen ? <FiX size={22} color="#333" /> : <FiMenu size={22} color="#333" />}
      </button>

      {/* Mobile overlay */}
      {isMobileOpen && (
        <div
          className="md:hidden fixed inset-0 bg-black/30 z-40"
          onClick={() => setIsMobileOpen(false)}
        />
      )}

    <AnimatePresence>
      <motion.div
        className={`side-nav side-nav-light side-nav-expand transition-width duration-600 bg-white shadow-md shadow-gray-200 fixed h-screen ${
          isMobileOpen ? "block z-50" : "hidden md:block z-40"
        }`}
        initial={{ width: "64px" }}
        animate={{ width: isExpanded || isMobileOpen ? "256px" : "64px" }}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {/* Sidebar content */}
        <div className="side-nav-header h-[70px] flex items-center justify-center bg-white ">
          <div className="logo inline-flex text-xl text-[#2E37A4] font-semibold items-center">
            <span className="text-2xl">
              <img src={logoImage} className="w-10" alt="none" />
            </span>
            <span className={`ml-2 ${isExpanded || isMobileOpen ? "" : "hidden"}`}>
              Vital<span className="text-[#2E37A4] font-semibold">X</span>
            </span>
          </div>
        </div>

        <div className="side-nav-content h-[calc(100vh-70px)]">
          <nav className="menu menu-light pt-5" onClick={() => setIsMobileOpen(false)}>
            <ul>
              {/* Menu items */}
              <li className="overflow-x-hidden relative">
                <Link
                  to="/clinic/dashboard"
                  className={`${
                    pathname === "/clinic/dashboard"
                      ? activeItemLinkClass
                      : itemLinkClass
                  }`}
                >
                  <i
                    className={`${
                      pathname === "/clinic/dashboard"
                        ? activeMenuIconClass
                        : menuIconClass
                    }`}
                  >
                    <img
                      src={AppointmentsIcon}
                      alt="none"
                      style={
                        pathname === "/clinic/dashboard"
                          ? { filter: filterClass }
                          : {}
                      }
                    />
                  </i>
                  <motion.span
                    className={`relative z-10 ${isExpanded || isMobileOpen ? "" : "hidden"}`}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0, width: 0 }}
                    transition={{ duration: 0.2 }}
                  >
                    Appointments
                  </motion.span>
                </Link>
              </li>

              <li className=" overflow-x-hidden  relative">
                <Link
                  to="/clinic/patient"
                  className={`${
                    pathname === "/clinic/patient"
                      ? activeItemLinkClass
                      : itemLinkClass
                  }`}
                >
                  <i
                    className={`${
                      pathname === "/clinic/patient"
                        ? activeMenuIconClass
                        : menuIconClass
                    }`}
                  >
                    <img
                      src={PatientsIcon}
                      alt="none"
                      style={
                        pathname === "/clinic/patient"
                          ? { filter: filterClass }
                          : {}
                      }
                    />
                  </i>
                  <motion.span
                    className={`relative z-10 ${isExpanded || isMobileOpen ? "" : "hidden"}`}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0, width: 0 }}
                    transition={{ duration: 0.2 }}
                  >
                    Patients
                  </motion.span>
                </Link>
              </li>

              <li className=" overflow-x-hidden  relative">
                <Link
                  to="/clinic/rapid-entry"
                  className={`${
                    pathname === "/clinic/rapid-entry"
                      ? activeItemLinkClass
                      : itemLinkClass
                  }`}
                >
                  <i
                    className={`${
                      pathname === "/clinic/rapid-entry"
                        ? activeMenuIconClass
                        : menuIconClass
                    }`}
                  >
                    <img
                      src={QRIcon}
                      alt="none"
                      style={
                        pathname === "/clinic/rapid-entry" ? { filter: filterClass } : {}
                      }
                    />
                  </i>
                  <motion.span
                    className={`relative z-10 ${isExpanded || isMobileOpen ? "" : "hidden"}`}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0, width: 0 }}
                    transition={{ duration: 0.2 }}
                  >
                    Rapid Entry
                  </motion.span>
                </Link>
              </li>

              <li className=" overflow-x-hidden  relative">
                <Link
                  to="/clinic/doctor"
                  className={`${
                    pathname === "/clinic/doctor"
                      ? activeItemLinkClass
                      : itemLinkClass
                  }`}
                >
                  <i
                    className={`${
                      pathname === "/clinic/doctor"
                        ? activeMenuIconClass
                        : menuIconClass
                    }`}
                  >
                    <img
                      src={DoctorIcon}
                      alt="none"
                      style={
                        pathname === "/clinic/doctor"
                          ? { filter: filterClass }
                          : {}
                      }
                    />
                  </i>
                  <motion.span
                    className={`relative z-10 ${isExpanded || isMobileOpen ? "" : "hidden"}`}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0, width: 0 }}
                    transition={{ duration: 0.2 }}
                  >
                    Doctor
                  </motion.span>
                </Link>
              </li>

              <li className=" overflow-x-hidden  relative">
                <Link
                  to="/clinic/prescriptions"
                  className={`${
                    pathname === "/clinic/prescriptions"
                      ? activeItemLinkClass
                      : itemLinkClass
                  }`}
                >
                  <i
                    className={`${
                      pathname === "/clinic/prescriptions"
                        ? activeMenuIconClass
                        : menuIconClass
                    }`}
                  >
                    <img
                      src={PrescriptionsIcon}
                      alt="none"
                      style={
                        pathname === "/clinic/prescriptions"
                          ? { filter: filterClass }
                          : {}
                      }
                    />
                  </i>
                  <motion.span
                    className={`relative z-10 ${isExpanded || isMobileOpen ? "" : "hidden"}`}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0, width: 0 }}
                    transition={{ duration: 0.2 }}
                  >
                    Prescriptions
                  </motion.span>
                </Link>
              </li>

              <li className=" overflow-x-hidden  relative">
                <Link
                  to="/clinic/billinglist"
                  className={`${
                    pathname === "/clinic/billinglist"
                      ? activeItemLinkClass
                      : itemLinkClass
                  }`}
                >
                  <i
                    className={`${
                      pathname === "/clinic/billinglist"
                        ? activeMenuIconClass
                        : menuIconClass
                    }`}
                  >
                    <img
                      src={BillingIcon}
                      alt="none"
                      style={
                        pathname === "/clinic/billinglist"
                          ? { filter: filterClass }
                          : {}
                      }
                    />
                  </i>
                  <motion.span
                    className={`relative z-10 ${isExpanded || isMobileOpen ? "" : "hidden"}`}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0, width: 0 }}
                    transition={{ duration: 0.2 }}
                  >
                    Billing
                  </motion.span>
                </Link>
              </li>

              <li className=" overflow-x-hidden  relative">
                <Link
                  to="/clinic/report"
                  className={`${
                    pathname === "/clinic/report"
                      ? activeItemLinkClass
                      : itemLinkClass
                  }`}
                >
                  <i
                    className={`${
                      pathname === "/clinic/report"
                        ? activeMenuIconClass
                        : menuIconClass
                    }`}
                  >
                    <img
                      src={BillingIcon}
                      alt="none"
                      style={
                        pathname === "/clinic/report"
                          ? { filter: filterClass }
                          : {}
                      }
                    />
                  </i>
                  <motion.span
                    className={`relative z-10 ${isExpanded || isMobileOpen ? "" : "hidden"}`}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0, width: 0 }}
                    transition={{ duration: 0.2 }}
                  >
                    Report
                  </motion.span>
                </Link>
              </li>

              <li className=" overflow-x-hidden  relative">
                <Link
                  to="/clinic/payment"
                  className={`${
                    pathname === "/clinic/payment"
                      ? activeItemLinkClass
                      : itemLinkClass
                  }`}
                >
                  <i
                    className={`${
                      pathname === "/clinic/payment"
                        ? activeMenuIconClass
                        : menuIconClass
                    }`}
                  >
                    <img
                      src={BillingIcon}
                      alt="none"
                      style={
                        pathname === "/clinic/payment"
                          ? { filter: filterClass }
                          : {}
                      }
                    />
                  </i>
                  <span className={`relative  ${isExpanded || isMobileOpen ? "" : "hidden"}`}>
                    Payment
                  </span>
                </Link>
              </li>

              {/* Add more menu items as needed */}
            </ul>
          </nav>
        </div>
      </motion.div>
    </AnimatePresence>
    </>
  );
};

export default SideBar;
